<template>
</template>

<script>
export default {
    data: function () {
        return {
            showSearch: false,
            search: '',
            row: false,
            modalData: {
                voucher: {},
            },
            modals: {
                voucher: false,
            },
            reports: [],
            bundle: false,
            bundlesValid: [],
            bundlesInvalid: [],
            vouchersValid: [],
            vouchersInvalid: [],
            viewportWidth: 0,
        }
    },
    props: [
        'url'
    ],
    computed: {
        reportCount() {
            return this.reports.length;
        },
        totalBundleCount() {
            return this.bundlesValid.length + this.bundlesInvalid.length;
        },
        totalVoucherCount() {
            return this.vouchersValid.length + this.vouchersInvalid.length;
        },
    },
    created() {
        this.viewportWidth = window.innerWidth;
        this.getResults();
    },
    mounted() {
        window.addEventListener('resize', function () {
            this.viewportWidth = window.innerWidth;
        }.bind(this));

        if (localStorage.row == 'true') {
            this.row = true;
        } else if (localStorage.row == 'false') {
            this.row = false;
        }
    },
    watch: {
        search(value) {
            this.filterResults();
        },
        viewportWidth(value) {
            if (value < 992) {
                this.row = false;
            };
        },
        // whenever row changes, this function will run
        row: function (newRow, oldRow) {
            localStorage.row = newRow;
        }
    },

    methods: {
        /**
         * To avoid issues where refreshless filtering has fewer results
         * than the currently selected page, we reset the page number any
         * time someone runs the filters
         *
         * Additionally, we reset the paginator to the 1st page
         * https://github.com/lokyoung/vuejs-paginate/issues/16
         *
         * @return {void}
         */
        filterResults: _.debounce(function() {
            this.getResults();
        }, 1000),

        getResults() {
            axios
                .post(this.url, {dashboard_free_search: this.search})
                .then(response => {
                    let data = response.data.data;

                    this.reports = data[0];
                    this.bundlesValid = data[1];
                    this.bundlesInvalid = data[2];
                    this.vouchersValid = data[3];
                    this.vouchersInvalid = data[4];
                })
                .catch(error => {
                    console.log(error.response);
                });
        },

        clearModalData () {
            this.modalData.voucher = {};
        },

        modalShow (modal, data) {
            if (modal == 'voucher') {
                this.$store.commit('voucherCode', data.code);
                this.$store.commit('productType', data.applies_to);
            }
            this.modalData[modal] = data;
            this.modals[modal] = true;
        },

        modalHide (modal) {
            this.modals[modal] = false;
        },

        voucherTitle (voucher) {
            let message = '';
            if(voucher.discount_type == 'percent') {
                if(voucher.discount_amount == 100) {
                    message = 'Free ' + voucher.applies_to + ' Check';
                } else {
                    message = Math.round(voucher.discount_amount) + '% off ' + voucher.applies_to + ' Check';
                }
            } else if (voucher.discount_type == 'fixed') {
                message = '£' + Math.round(voucher.discount_amount) + ' off '  + voucher.applies_to + ' Check';
            }
            return message;
        },

        showRedeemFreeReport() {
            $('#vrm-input-free-report-modal').modal('show');
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize');
    },
    components: {
    }
}
</script>
